module.exports = __webpack_public_path__ + "static/img/heart-no-love.72271bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3kfan/heart-no-love.png
// module id = EEZ4
// module chunks = 0